import { pawnshop_reports_settings_service } from "../../../api/restclient";

export const getBranchCategoryCollection = () => {
  try {
    return pawnshop_reports_settings_service.get("/settings/branchCategories");
  } catch {
    return Promise.resolve();
  }
};

export const getSingleBranchCategory = (data) => {
  try {
    const params = {};
    return pawnshop_reports_settings_service.get(
      `/settings/branchCategories${data.id}`,
      params
    );
  } catch {
    return Promise.resolve();
  }
};

export const addBranchCategory = (data) => {
  try {
    var urlParams = new URLSearchParams();
    urlParams.append("name", data.name);
    urlParams.append("maximum", data.maximum);
    return pawnshop_reports_settings_service.post(
      `/settings/branchCategories?${urlParams.toString()}`
    );
  } catch {
    return Promise.resolve();
  }
};

export const deleteBranchCategory = (data) => {
  try {
    const params = {};
    return pawnshop_reports_settings_service.delete(
      `/settings/branchCategories/${data.id}`,
      params
    );
  } catch {
    return Promise.resolve();
  }
};

export const updateBranchCategory = (data) => {
  try {
    var urlParams = new URLSearchParams();
    urlParams.append("name", data.name);
    urlParams.append("maximum", data.maximum);
    return pawnshop_reports_settings_service.put(
      `/settings/branchCategories/${data.id}?${urlParams.toString()}`
    );
  } catch {
    return Promise.resolve();
  }
};
